export default class DtoTerritoryEmissionsActivity {
    constructor(obj) {
        this.dataSource = obj.dataSource
        this.categoryActivity = obj.categoryActivity
        this.parameterCode = obj.parameterCode
        this.name = obj.name
        this.companyFlowKgDay = obj.companyFlowKgDay
        this.employeeFlowKgDay = obj.employeeFlowKgDay
    }
}